import { PreLoadingContainer } from './styled'
import { LinearProgress } from '@mui/material'
import { FC } from 'react'
import { IPropsSuspenseLoading } from './IProps'

const PreLoading: FC<IPropsSuspenseLoading> = ({ position = 'parent' }) => {
  return (
    <PreLoadingContainer position={position}>
      <LinearProgress />
    </PreLoadingContainer>
  )
}

export default PreLoading
